import { render, staticRenderFns } from "./CreateForm.vue?vue&type=template&id=11785a43&scoped=true"
import script from "./CreateForm.vue?vue&type=script&lang=ts"
export * from "./CreateForm.vue?vue&type=script&lang=ts"
import style0 from "./CreateForm.vue?vue&type=style&index=0&id=11785a43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11785a43",
  null
  
)

export default component.exports